export enum DispatchProModule {
    RouteManager = 1
}

export function getDispatchProModule(id: number){
    switch(id){
        case DispatchProModule.RouteManager: return DispatchProModule.RouteManager;
        default: return undefined;
    }
}